import { Grid } from '@material-ui/core';
import Body from 'app/shared/components/typography/body/Body';
import styledFuncs from 'app/styles/styledFuncs';
import { NameValueListItems } from 'app/tools/general.types';
import React from 'react';
import styled from 'styled-components/macro';

type GridItemProps = {
  className?: string;
  title: string;
  content: string;
  wide?: boolean;
};
const GridItemBase = ({
  className,
  title,
  content,
  wide = false,
}: GridItemProps) => (
  <Grid item xs={wide ? 12 : 4} {...{ className }}>
    <Body tiny>{title}</Body>
    <Body tiny>{content}</Body>
  </Grid>
);
const GridItem = styled(GridItemBase)`
  > *:nth-child(1) {
    font-size: ${styledFuncs.pxToRem(13)};
  }
  > *:nth-child(2) {
    font-weight: 400;
    word-break: break-word;
  }
`;

type Props = {
  listItems: NameValueListItems;
};

export default function NameValueGrid({
  listItems,
}: Props): JSX.Element {
  return (
    <>
      <Grid container spacing={1}>
        {listItems.map(({ name, value }) => (
          <GridItem
            key={name}
            title={name}
            content={String(value)}
            wide={name === 'Description'}
          />
        ))}
      </Grid>
    </>
  );
}
